var React = require('react');
var dd = require('react-dd');
var _ = require('lodash');

var HelpTooltip = require('./HelpTooltip');

module.exports = dd.createClass({
	propTypes: {
		fields: React.PropTypes.object.isRequired,
		errors: React.PropTypes.object.isRequired,
		buildInput: React.PropTypes.func.isRequired,

		scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
		label_size: React.PropTypes.number,
		input_size: React.PropTypes.number
	},
	render: function(){
		var fields = this.props.fields;
		var errors = this.props.errors;
		var buildInput = this.props.buildInput;

		var scale = this.props.scale || 'sm';
		var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
		var input_size = this.props.input_size || (12 - label_size);

		var layout = _.isArray(this.props.layout) ? this.props.layout : _.map(_.keys(fields), function(name){
			return [name];
		});

		return dd.div({className: 'HorizontalFields'},
			_.map(layout, function(row, i){
				return dd.div({key: i, className: 'form-group'},
					_.map(row, function(name, j){
						return HorizontalField({
							key: j,
							field_name: name,
							fields: fields,
							errors: errors,
							buildInput: buildInput,

							scale: scale,
							label_size: label_size,
							input_size: row.length > 1 ? (input_size - label_size) / 2 : input_size
						});
					})
				);
			})
		);
	}
});

var HorizontalField = dd.createClass({
	propTypes: {
		//field_name: String or Component //basically required, if not a field name it'll stick it in a div at the proper col-width
		fields: React.PropTypes.object.isRequired,
		errors: React.PropTypes.object.isRequired,
		buildInput: React.PropTypes.func.isRequired,

		scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
		label_size: React.PropTypes.number,
		input_size: React.PropTypes.number
	},
	render: function(){
		var name = this.props.field_name;
		var field = this.props.fields[name];
		var error = this.props.errors[name];
		var buildInput = this.props.buildInput;

		var scale = this.props.scale || 'sm';
		var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
		var input_size = this.props.input_size || (12 - label_size);

		if(!field){
			return dd.div({className: 'col-' + scale + '-' + (label_size + input_size)}, name);//render a placeholder with whatever name is (i.e. can pass in a component)
		}

		var field_label = field.label || name;
		var tooltip = field.tooltip ? HelpTooltip({title: field_label, content: field.tooltip}) : null;

		return dd.div({className: 'HorizontalField ' + (error ? ' has-error' : '')},
			dd.label({className: 'control-label col-' + scale + '-' + label_size},
				field.type == 'checkbox' ? null : field_label + ' ',
				field.type !== 'checkbox' ? tooltip : null
			),
			dd.div({className: ' col-' + scale + '-' + input_size},
				buildInput(field, name),
				field.type == 'checkbox' ? ' ' : null,
				field.type == 'checkbox' ? tooltip : null,
				error ? dd.span({className: 'help-block'}, error) : null,
				field.help_text ? dd.span({className: 'help-block'}, field.help_text) : null
			)
		);
	}
});

var ButtonArea = dd.createClass({
	propTypes: {
		scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
		label_size: React.PropTypes.number,
		input_size: React.PropTypes.number,

		right_align_buttons: React.PropTypes.bool
	},
	render: function(){
		var scale = this.props.scale || 'sm';
		var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
		var input_size = this.props.input_size || (12 - label_size);

		return dd.div({className: 'HorizontalFields'},//hack to fix layout
			dd.div({className: 'form-group ButtonArea'},
				dd.label({className: 'control-label col-' + scale + '-' + label_size}, ' '),
				dd.div({className: 'col-' + scale + '-' + input_size + ' ' + (this.props.right_align_buttons ? 'text-right' : '')},
					this.props.children
				)
			)
		);
	}
});

module.exports.FormButtons = dd.createClass({
	propTypes: {
		scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
		label_size: React.PropTypes.number,
		input_size: React.PropTypes.number,

		onCancel: React.PropTypes.func,
		onDelete: React.PropTypes.func,
		onDiscard: React.PropTypes.func,
		submit_btn_text: React.PropTypes.string,

		right_align_buttons: React.PropTypes.bool
	},
	render: function(){
		var scale = this.props.scale || 'sm';
		var onCancel = this.props.onCancel;
		var onDelete = this.props.onDelete;
		var onDiscard = this.props.onDiscard;
		var submit_btn_text = this.props.submit_btn_text;


		var buttons = [];
		buttons.push(dd.button({type: 'submit', className: 'btn btn-primary btn-' + scale}, submit_btn_text || 'Save'));
		if(onCancel){
			buttons.push(dd.button({className: 'btn btn-default btn-' + scale, onClick: onCancel}, 'Cancel'));
		}
		if(onDiscard){
			buttons.push(dd.button({className: 'btn btn-default btn-' + scale, onClick: onDiscard}, 'Undo Changes'));
		}
		if(onDelete){
			buttons.push(dd.button({className: 'btn btn-danger btn-' + scale, onClick: onDelete}, 'Delete'));
		}
		if(this.props.right_align_buttons){
			buttons.reverse();
		}
		return ButtonArea({
				scale: scale,
				label_size: this.props.label_size,
				input_size: this.props.input_size,
				right_align_buttons: !!this.props.right_align_buttons
			},
			_.map(buttons, function(button, i){
				return dd.span({key: i}, button, ' ');
			})
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/HorizontalFields.js
// module id = 22
// module chunks = 0 1 2 3 4